import { useEffect as m } from "react";
import t from "./index85.mjs";
import { useStorage as S } from "./index50.mjs";
import { StorageKey as i } from "./index49.mjs";
import { CookiesEnum as s } from "./index48.mjs";
const f = (o) => t.get(s.BrowserSessionActiveId) === o.toString(), u = (o, n = {}) => {
  const e = t.get(s.LoginId) ?? "shared", r = S(`${i.SessionStorePrefix}${e}:${o}`, n);
  return m(() => {
    f(e) || (r.removeByPrefix(i.SessionStorePrefix), t.set(s.BrowserSessionActiveId, e.toString(), {
      sameSite: "strict",
      path: "/"
    }));
  }, [e, r.removeByPrefix]), r;
};
export {
  u as useSessionStore
};
